<script>
    import Header from "./header.svelte";
    import GameIcon from "./game-icon.svelte";
    import Arrow from "./arrow.svelte";
    import { apiHost, token, isOut, historyState, games } from "./stores";

    const coords = [
        [],
        [{ width: 40, height: 40 * 1.35, x: 32, y: 12 }],
        [
            { width: 36, height: 36 * 1.35, x: 6.5, y: 19 },
            { width: 36, height: 36 * 1.35, x: 56, y: 19 },
        ],
        [
            { width: 28, height: 28 * 1.35, x: 5, y: 25 },
            { width: 28, height: 28 * 1.35, x: 35, y: 25 },
            { width: 28, height: 28 * 1.35, x: 65, y: 25 },
        ],
        [
            { width: 24, height: 24 * 1.35, x: 3, y: 25 },
            { width: 24, height: 24 * 1.35, x: 26, y: 25 },
            { width: 24, height: 24 * 1.35, x: 49, y: 25 },
            { width: 24, height: 24 * 1.35, x: 72, y: 25 },
        ],
        [
            { width: 22, height: 22 * 1.35, x: 8, y: 12 },
            { width: 22, height: 22 * 1.35, x: 40, y: 12 },
            { width: 22, height: 22 * 1.35, x: 72, y: 12 },
            { width: 22, height: 22 * 1.35, x: 24, y: 39 },
            { width: 22, height: 22 * 1.35, x: 56, y: 39 },
        ],
        [
            { width: 22, height: 22 * 1.35, x: 8, y: 12 },
            { width: 22, height: 22 * 1.35, x: 40, y: 12 },
            { width: 22, height: 22 * 1.35, x: 72, y: 12 },
            { width: 22, height: 22 * 1.35, x: 8, y: 39 },
            { width: 22, height: 22 * 1.35, x: 40, y: 39 },
            { width: 22, height: 22 * 1.35, x: 72, y: 39 },
        ],
        [
            { width: 22, height: 22 * 1.35, x: 8, y: 12 },
            { width: 22, height: 22 * 1.35, x: 30, y: 12 },
            { width: 22, height: 22 * 1.35, x: 52, y: 12 },
            { width: 22, height: 22 * 1.35, x: 74, y: 12 },
            { width: 22, height: 22 * 1.35, x: 18, y: 39 },
            { width: 22, height: 22 * 1.35, x: 40, y: 39 },
            { width: 22, height: 22 * 1.35, x: 62, y: 39 },
        ],
        [
            { width: 22, height: 22 * 1.35, x: 8, y: 12 },
            { width: 22, height: 22 * 1.35, x: 30, y: 12 },
            { width: 22, height: 22 * 1.35, x: 52, y: 12 },
            { width: 22, height: 22 * 1.35, x: 74, y: 12 },
            { width: 22, height: 22 * 1.35, x: 8, y: 39 },
            { width: 22, height: 22 * 1.35, x: 30, y: 39 },
            { width: 22, height: 22 * 1.35, x: 52, y: 39 },
            { width: 22, height: 22 * 1.35, x: 74, y: 39 },
        ],
    ];

    const idToGame = {
        179: "sun_tech_walker",
        180: "khodja",
        181: "khodjanasreddin",
        182: "suntechnikchess",
        184: "khodjanasreddinloto",
        185: "suntechnikloto",
        186: "millenium_crazy_hockey_tadj",
        187: "millenium_gold_basketball_tadj",
        188: "millenium_cocktail_football_tadj",
        189: "millenium_resident_of_nfl_tadj",
        190: "millenium_buzkashi_tadj",
        192: "millenium_masha_and_bear",
        193: "millenium_crazy_hockey_tadj",
        194: "millenium_gold_basketball_tadj",
        195: "millenium_cocktail_football_tadj",
        196: "millenium_resident_of_nfl_tadj",
        198: "millenium_sinbad",
        199: "millenium_3wishes",
        200: "millenium_gnoms_mine",
        201: "millenium_hot_strike",
        203: "millenium_india_night",
        204: "millenium_lucky_menu",
        205: "millenium_lucky_saloon",
        206: "millenium_pharaohs_artifact",
        207: "millenium_rabbit_illusion",
        208: "millenium_shaolino",
        209: "millenium_aladdin",
        210: "millenium_arabian_delight",
        211: "millenium_chicago",
        212: "millenium_circus_magic",
        213: "millenium_flame_joker",
        218: "millenium_monkey_island",
        219: "millenium_fruit_show",
        220: "millenium_fairy_forest",
        222: "millenium_dolphins_lagoon",
        223: "millenium_arctic_gold",
        231: "millenium_cocktail_football_new",
        232: "millenium_crazy_hockey_new",
        235: "millenium_gold_basketball_new",
        237: "millenium_resident_of_nfl_new",
        238: "millenium_buzkashi_new",
        240: "inbet_irish_story_keno",
        241: "khodjanasreddinlotosport",
        242: "suntechniklotosport",
        243: "millenium_god_of_dead",
        244: "inbet_irish_story_3x3_pull_tabs",
        245: "millenium_box_of_ra_6",
        246: "inbet_diamond_rich_life_3x3",
        247: "inbet_buffalo_spirit_3x3_pull_tabs",
        248: "inbet_haunted_money_3x3_pull_tabs",
        249: "inbet_irish_story_3x3",
        250: "inbet_diamond_rich_life_3x3_pull_tabs",
        251: "inbet_haunted_money_3x3",
        252: "inbet_buffalo_spirit_3x3",
    };

    const idToIcons = {
        179: 0,
        180: 1,
        181: 1,
        182: 0,
        184: 1,
        185: 0,
        186: 2,
        187: 3,
        188: 4,
        189: 5,
        190: 6,
        192: 36,
        193: 2,
        194: 3,
        195: 4,
        196: 5,
        198: 7,
        199: 20,
        200: 22,
        201: 8,
        203: 18,
        204: 38,
        205: 23,
        206: 35,
        207: 13,
        208: 9,
        209: 21,
        210: 17,
        211: 10,
        212: 14,
        213: 37,
        218: 11,
        219: 12,
        220: 15,
        222: 16,
        223: 19,
        231: 4,
        232: 2,
        235: 3,
        237: 5,
        238: 6,
        240: 24,
        241: 1,
        242: 0,
        243: 33,
        244: 25,
        245: 34,
        246: 26,
        247: 27,
        248: 28,
        249: 29,
        250: 30,
        251: 31,
        252: 32,
    };

    const icons = [
        ["san.png", "sant_act.png"], // 0
        ["hoj.png", "hoja_act.png"], // 1
        ["hock.png", "hockey_act.png"], // 2
        ["basket.png", "basketball_act.png"], // 3
        ["foot.png", "football_act.png"], // 4
        ["nfl.png", "nfl_act.png"], // 5
        ["buzkashi.png", "buzkashi_act.png"], // 6
        ["sinbad.png", "sinbad_act.png"], // 7
        ["mevaho_2024.png", "hotstrike_act.png"], // 8
        ["shaolino.png", "shaolino_act.png"], // 9
        ["mashinho-2024.png", "chicago_act.png"], // 10
        ["monkey.png", "monkey_act.png"], // 11
        ["fruit_show_2024.png", "fruit_act.png"], // 12
        ["rabbit.png", "rabbit_act.png"], // 13
        ["circus.png", "circus_act.png"], // 14
        ["fairy_forest.png", "fairy_forest.png"], // 15
        ["delfinho-2024.png", "dolphins_lagoon.png"], // 16
        ["millenium_arabian_delight.png", "millenium_arabian_delight.png"], // 17
        ["millenium_india_night.png", "millenium_india_night.png"], // 18
        ["pingvinho-2024.png", "millenium_arctic_gold.png"], // 19
        ["millenium_3wishes.png", "millenium_3wishes.png"], // 20
        ["millenium_aladdin.png", "millenium_aladdin.png"], // 21
        ["millenium_gnoms_mine.png", "millenium_gnoms_mine.png"], // 22
        ["millenium_lucky_saloon.png", "millenium_lucky_saloon.png"], // 23
        ["inbet_irish_story_keno.png", "inbet_irish_story_keno.png"], // 24
        [
            "inbet_irish_story_3x3_pull_tabs.png",
            "inbet_irish_story_3x3_pull_tabs.png",
        ], // 25
        ["inbet_diamond_rich_life_3x3.png", "inbet_diamond_rich_life_3x3.png"], // 26
        [
            "bukaho-2024.png",
            "bukaho-2024.png",
        ], // 27
        [
            "inbet_haunted_money_3x3_pull_tabs.png",
            "inbet_haunted_money_3x3_pull_tabs.png",
        ], // 28
        ["inbet_irish_story_3x3.png", "inbet_irish_story_3x3.png"], // 29
        [
            "inbet_diamond_rich_life_3x3_pull_tabs.png",
            "inbet_diamond_rich_life_3x3_pull_tabs.png",
        ], // 30
        ["inbet_haunted_money_3x3.png", "inbet_haunted_money_3x3.png"], // 31
        ["inbet_buffalo_spirit_3x3.png", "inbet_buffalo_spirit_3x3.png"], // 32
        ["millenium_god_of_dead.png", "millenium_god_of_dead.png"], // 33
        ["millenium_box_of_ra_6.png", "millenium_box_of_ra_6.png"], // 34
        ["millenium_pharaohs_artifact.png", "millenium_pharaohs_artifact.png"], // 35
        ["millenium_masha_and_bear.png", "millenium_masha_and_bear.png"], // 36
        ["millenium_flame_joker.png", "millenium_flame_joker.png"], // 37
        ["millenium_lucky_menu.png", "millenium_lucky_menu.png"], // 38
    ];

    $: sortedGames = $games
        .filter((id) => id in idToGame)
        .sort((a, b) => idToIcons[a] - idToIcons[b]);

    const saveHighscore = () => {
        fetch(`${apiHost}v1/move-to-poll`, {
            headers: new Headers({
                Authorization: "Bearer " + $token,
            }),
        })
            .then((r) => r.json())
            .then((r) => {
                if (r.success === true && r.data === true) {
                    $isOut = true;
                }
            });
    };

    const backHighscore = () => {
        fetch(`${apiHost}v1/move-from-poll`, {
            headers: new Headers({
                Authorization: "Bearer " + $token,
            }),
        })
            .then((r) => r.json())
            .then((r) => {
                if (r.success === true && r.data === true) {
                    $isOut = false;
                }
            });
    };
</script>

<div>
    <Header />
    {#if $historyState === 0}
        {#if sortedGames.length <= 8}
            {#each sortedGames as id, i}
                <GameIcon
                    image={icons[idToIcons[id]][0]}
                    hover={icons[idToIcons[id]][1]}
                    game={idToGame[id]}
                    x={coords[sortedGames.length][i].x}
                    y={coords[sortedGames.length][i].y}
                    width={coords[sortedGames.length][i].width}
                    height={coords[sortedGames.length][i].height}
                />
            {/each}
            <div class="choose" />
            <div class="good-luck" />
            {#if $isOut > 0}
                <div
                    role="presentation"
                    class="mo poll"
                    on:click={() => backHighscore()}
                />
            {:else}
                <div
                    role="presentation"
                    class="mo"
                    on:click={() => saveHighscore()}
                />
            {/if}
        {:else}
            <div
                id="game-list"
                style="position:absolute;top:12vh;height:84vh;overflow-y:scroll"
            >
                <Arrow top={15}></Arrow>
                {#each sortedGames as id, i}
                    <GameIcon
                        image={icons[idToIcons[id]][0]}
                        hover={icons[idToIcons[id]][1]}
                        game={idToGame[id]}
                        x={coords[8][i % 4].x}
                        y={0 +
                            Math.floor(i / 4) *
                                (coords[8][5].y - coords[8][0].y)}
                        width={coords[8][i % 4].width}
                        height={coords[8][i % 4].height}
                    />
                {/each}
                {#if sortedGames.length % 4 === 0}
                    <div
                        style={`position: absolute;width:${coords[8][0].width}vw;height:${coords[8][0].height}vh;top:${0 + Math.floor(sortedGames.length / 4) * (coords[8][5].y - coords[8][0].y)}vh`}
                    ></div>
                {/if}
                <Arrow top={80} rotation={180}></Arrow>
            </div>
            {#if $isOut > 0}
                <div
                    role="presentation"
                    class="mo poll"
                    on:click={() => backHighscore()}
                />
            {:else}
                <div
                    role="presentation"
                    class="mo"
                    on:click={() => saveHighscore()}
                />
            {/if}
        {/if}
    {/if}
</div>

<style>
    div {
        width: 100%;
        height: 100%;
        background-image: url(../assets/fon.jpg);
        background-size: 100% 100%;
    }
    div.good-luck {
        position: absolute;
        top: 77vh;
        left: 50vw;
        width: 14.3229vw;
        height: 14.9074vh;
        transform: translateX(-50%);
        background-image: url(../assets/good_luck.png);
        background-size: 100% 100%;
    }
    div.choose {
        position: absolute;
        top: 68vh;
        left: 50vw;
        width: 46.5625vw;
        height: 7.1296vh;
        transform: translateX(-50%);
        background-image: url(../assets/choose_vis.png);
        background-size: 100% 100%;
    }
    div.mo {
        position: absolute;
        top: 76vh;
        left: 80vw;
        width: 14vw;
        height: 21vh;
        background-image: url(../assets/M_O_norm.png);
        background-size: 100% 100%;
    }
    div.mo::before {
        content: "БАРОИ\A0ГИРИФТАНИ\A0ПУЛ\A0ДАР КАССА\A0КЛИК\A0КУНЕД";
        color: #fff;
        text-transform: capitalize;
        top: -2em;
        position: relative;
        text-shadow: 5px 5px 10px #0024ff;
        font-weight: bold;
        animation: blink 1.5s linear infinite;
        display: inline-block;
        text-align: center;
    }
    @keyframes blink {
        50% {
            opacity: 0;
        }
    }
    div.mo:hover {
        background-image: url(../assets/M_O_act.png);
    }
    div.mo.poll {
        background-image: url(../assets/M_O_acting.png);
    }
    div.mo.poll::before {
        content: "БА КАССА РАВЕД";
        color: #4af284;
        text-transform: capitalize;
        top: -1em;
        position: relative;
        text-shadow: 5px 5px 10px #0024ff;
        font-weight: bold;
        display: block;
        text-align: center;
    }
    div.mo.poll:hover {
        background-image: url(../assets/M_O_acting.png);
    }
</style>
